export default {
    hasAccount(state) {
        return Object.keys(state.account).length !== 0
    },

    mobileIsVerified(state) {
        return state.middlewares.mobile_verified
    },

}